import MainLayout from '@/layouts/MainLayout';
import UsageStatsWidget from '@/components/podcasts/UsageStatsWidget';
import UsageHistory from '@/components/podcasts/UsageHistory';
import RedeemCouponWidget from '@/components/podcasts/RedeemCouponWidget';

export default function CreditsPage() {
    return (
        <MainLayout>
             <div className="flex bg-slate-50 min-h-[calc(100vh-80px)]">
                <main className="flex-1 p-6 md:p-8 overflow-y-auto">
                    <div className="max-w-7xl mx-auto space-y-6">
                        <div className="flex items-center justify-between">
                            <h1 className="text-3xl font-bold text-gray-900">Credits & Usage</h1>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {/* Left Column: Stats & Actions */}
                            <div className="md:col-span-1 space-y-6">
                                <UsageStatsWidget />
                                <RedeemCouponWidget />
                            </div>

                            {/* Right Column: History */}
                            <div className="md:col-span-2">
                                <UsageHistory />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </MainLayout>
    );
}
